import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import type { WizardAction } from "./wizardShared";
import type { EventValidationStepIssues } from "./EventWizard";

const actionVerb: Record<WizardAction, string> = {
  draft: "save",
  publish: "publish",
  save: "update",
  schedule: "schedule",
};

// Red bubble above the wizard footer buttons that lists every problem
// blocking a save, grouped by step (Moeen, 2026-09-25).
const EventValidationBubble = ({
  action,
  groups,
  onClose,
}: {
  action: WizardAction;
  groups: EventValidationStepIssues[];
  onClose: () => void;
}): React.ReactElement => (
  <div
    role="alert"
    data-testid="event-validation-bubble"
    className="absolute bottom-[calc(100%+12px)] right-0 z-20 max-h-[60vh] w-[min(440px,calc(100vw-32px))] overflow-y-auto rounded-[8px] border border-[#DC2626] bg-white px-[16px] py-[12px] text-left text-[13px] leading-[1.45] text-[#B91C1C] shadow-lg"
  >
    <div className="flex items-start justify-between gap-[12px]">
      <p className="m-0 font-semibold">
        Fix these items to {actionVerb[action]} this event:
      </p>
      <button
        type="button"
        aria-label="Close"
        onClick={onClose}
        className="-mr-[4px] -mt-[2px] flex h-[24px] w-[24px] shrink-0 items-center justify-center rounded-full border-0 bg-transparent p-0 text-[#B91C1C] hover:bg-[#FEF2F2]"
      >
        <CloseIcon sx={{ fontSize: 16 }} />
      </button>
    </div>
    {groups.map((group) => (
      <div key={group.step} className="mt-[8px]">
        <p className="m-0 font-bold">
          Step {group.step}: {group.title}
        </p>
        <ul className="m-0 mt-[2px] list-disc pl-[22px]">
          {group.messages.map((message, index) => (
            <li key={`${group.step}-${index}`}>{message}</li>
          ))}
        </ul>
      </div>
    ))}
  </div>
);

export default EventValidationBubble;
